document.addEventListener('DOMContentLoaded', () => {
    // Main selectors and core state variables
    let tagCheckboxes = Array.from(document.querySelectorAll('.tag-checkbox'));
    let selectedFilterTabs = Array.from(document.querySelectorAll('.filter_tab'));
    const loadMoreButton = document.querySelector('.js-load-more');
    const viewLessButton = document.querySelector('.js-view-less');
    const loader = document.querySelector('.loader');
    // Pagination metadata elements (may be present or not)
    let nextpageUrl = document.querySelector('[data-next-link]') ? document.querySelector('[data-next-link]').value : null;
    let prevpageUrl = document.querySelector('[data-prev-link]') ? document.querySelector('[data-prev-link]').value : null;
    let currentpage = parseInt(document.querySelector('[data-this-page]') ? document.querySelector('[data-this-page]').value : 1);
    let totalpage = parseInt(document.querySelector('[data-all-pages]') ? document.querySelector('[data-all-pages]').value : 1);

    // The URL that points to the collection / blog main url (page 1). Option B uses blog.url without page param.
    const firstPageUrl = document.querySelector('[data-coll-url]') ? document.querySelector('[data-coll-url]').value : window.location.pathname;

    // Keep track of how many posts were present on initial page load (used by some logic)
    const initialPostsCount = document.querySelectorAll('ul.blog__posts > li:not(.tag):not(.spacer)').length || 0;

    // Lazy-fetch caching
    let allPagesFetched = false; // becomes true after we've fetched to the end
    let allArticles = []; // array of { html: string, tags: [..] } for posts we've loaded/cached

    // Helper: create element from HTML string
    function createElementFromHTML(htmlString) {
        const div = document.createElement('div');
        div.innerHTML = htmlString.trim();
        return div.firstElementChild;
    }

    // Initialize cache from currently-rendered posts on page load
    function initCacheFromDOM() {
        allArticles = [];
        const currentPosts = document.querySelectorAll('ul.blog__posts li:not(.tag):not(.spacer)');
        currentPosts.forEach(post => {
            const tags = post.dataset.tags ? post.dataset.tags.split(',').map(t => t.trim()).filter(Boolean) : [];
            allArticles.push({ html: post.outerHTML, tags: tags });
        });
        // If we're already on last page, mark allPagesFetched true
        if (currentpage >= totalpage) allPagesFetched = true;
        else allPagesFetched = false;
    }

    initCacheFromDOM();

    // Fetch a page and store posts in cache. Returns an object with metadata (next, prev, page) and html.
    async function fetchAndStorePage(url) {
        if (!url) return null;
        try {
            const resp = await fetch(url);
            const html = await resp.text();
            let tempDiv = document.createElement('div');
            tempDiv.innerHTML = html;
            let posts = tempDiv.querySelectorAll('ul.blog__posts li:not(.tag):not(.spacer)');
            posts.forEach(p => {
                const tags = p.dataset.tags ? p.dataset.tags.split(',').map(t => t.trim()).filter(Boolean) : [];
                allArticles.push({ html: p.outerHTML, tags: tags });
            });

            // Update next/prev/current based on returned HTML
            let nextElem = tempDiv.querySelector('[data-next-link]');
            let prevElem = tempDiv.querySelector('[data-prev-link]');
            let thisPageElem = tempDiv.querySelector('[data-this-page]');

            let meta = {};
            meta.next = nextElem ? nextElem.value : null;
            meta.prev = prevElem ? prevElem.value : null;
            meta.page = thisPageElem ? parseInt(thisPageElem.value) : null;

            return { html, meta };
        } catch (err) {
            console.error('Error fetching page:', err);
            return null;
        }
    }

    // Fetch remaining pages sequentially until the end (used only if filter is applied and we need all pages)
    async function fetchRemainingPagesSequentially() {
        // Use nextpageUrl to continue
        while (!allPagesFetched && nextpageUrl) {
            const fetched = await fetchAndStorePage(nextpageUrl);
            if (!fetched) break;
            // try to update nextpageUrl and currentpage from newly fetched HTML
            let tempDiv = document.createElement('div');
            tempDiv.innerHTML = fetched.html;
            let nextElem = tempDiv.querySelector('[data-next-link]');
            let thisPageElem = tempDiv.querySelector('[data-this-page]');
            let prevElem = tempDiv.querySelector('[data-prev-link]');
            if (nextElem) {
                nextpageUrl = nextElem.value;
            } else {
                nextpageUrl = null;
            }
            if (prevElem) prevpageUrl = prevElem.value;
            if (thisPageElem) currentpage = parseInt(thisPageElem.value);
            if (!nextpageUrl || currentpage >= totalpage) {
                allPagesFetched = true;
                nextpageUrl = null;
            }
        }
    }

    // Update visibility of Load More and View Less buttons based on pagination state
    function updateButtonVisibility() {
        // View less
        if (viewLessButton) {
            if (currentpage > 1) {
                viewLessButton.parentElement.style.display = "";
            } else {
                viewLessButton.parentElement.style.display = "none";
            }
        }
        // Load more
        if (loadMoreButton) {
            if (currentpage === totalpage || !nextpageUrl) {
                loadMoreButton.style.display = 'none';
            } else {
                loadMoreButton.style.display = '';
            }
        }
    }

    // -- FILTERS LOGIC --
    // New filterArticles: lazy fetch remaining pages only when filter is applied and not all pages fetched
    const filterArticles = async () => {
        // Refresh checkboxes in case DOM changed
        tagCheckboxes = Array.from(document.querySelectorAll('.tag-checkbox'));

        const selectedTags = Array.from(tagCheckboxes)
            .filter(checkbox => checkbox.checked)
            .map(checkbox => checkbox.value);

        // If no filters selected -> show only FIRST PAGE content by reloading first page
        // If no filters selected -> show only FIRST PAGE content by reloading first page
if (selectedTags.length === 0) {

    if (!firstPageUrl) {
        console.error('No first page URL (data-coll-url) found. Cannot reset to first page.');
        return;
    }
    loader && (loader.style.display = 'block');

    try {
        const resp = await fetch(firstPageUrl);
        const html = await resp.text();
        let tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;

        // Replace posts in DOM with first-page posts
        let firstPagePosts = tempDiv.querySelectorAll('ul.blog__posts li:not(.tag):not(.spacer)');
        const container = document.querySelector('ul.blog__posts');
        if (!container) {
            console.error('No blog__posts container found.');
            loader && (loader.style.display = 'none');
            return;
        }
        container.innerHTML = '';
        firstPagePosts.forEach(post => container.appendChild(post.cloneNode(true)));

        // Reset pagination variables from returned HTML
        nextpageUrl = tempDiv.querySelector('[data-next-link]') ? tempDiv.querySelector('[data-next-link]').value : null;
        prevpageUrl = tempDiv.querySelector('[data-prev-link]') ? tempDiv.querySelector('[data-prev-link]').value : null;
        currentpage = tempDiv.querySelector('[data-this-page]') ? parseInt(tempDiv.querySelector('[data-this-page]').value) : 1;
        allPagesFetched = currentpage >= totalpage;

        // Rebuild cache
        initCacheFromDOM();

        // Show load more button wrapper based on availability
        const loadMoreWrap = document.querySelector('.load-more_wrap');
        if (loadMoreWrap) loadMoreWrap.style.display = nextpageUrl ? "block" : "none";

        loader && (loader.style.display = 'none');
        updateButtonVisibility();

        // 🔥 FIX — REINITIALIZE SCRIPTS AFTER DOM RESET
        if (typeof afterButtonClickInit === "function") {
            afterButtonClickInit();
        }
        setTimeout(() => {
            if (typeof applyResponsiveLimit === "function") {
                applyResponsiveLimit();
            }
        }, 60);

    } catch (error) {
        loader && (loader.style.display = 'none');
        console.error('Error resetting to first page:', error);
    }

    return;
}


        // If filters selected and we haven't yet fetched all pages, fetch pages sequentially (lazy) so filter covers them too
        if (!allPagesFetched && nextpageUrl) {
            loader && (loader.style.display = 'block');
            await fetchRemainingPagesSequentially();
            loader && (loader.style.display = 'none');
        }

        // Now filter across allArticles (which contains posts loaded so far)
        const container = document.querySelector('ul.blog__posts');
        if (!container) return;
        container.innerHTML = '';
        const filtered = allArticles.filter(article => {
            const articleTags = article.tags || [];
            return selectedTags.some(tag => articleTags.includes(tag));
        });

        // If no results found, show a friendly message (optional)
        if (filtered.length === 0) {
            container.innerHTML = '<li class="no-results">No posts match the selected filters.</li>';
        } else {
            filtered.forEach(a => container.appendChild(createElementFromHTML(a.html)));
        }

        // Since filtered view is expected to show results across pages, hide Load More (user sees complete filtered set)
        const loadMoreWrap = document.querySelector('.load-more_wrap');
        if (loadMoreWrap) loadMoreWrap.style.display = 'none';

        // ensure standard visibility updates, then explicitly hide View Less for filtered view
        updateButtonVisibility();

        // Hide View Less button too while filters are active
        if (viewLessButton && viewLessButton.parentElement) {
            viewLessButton.parentElement.style.display = "none";
        }

        if (typeof afterButtonClickInit === "function") {
            afterButtonClickInit();
        }

    };

    // Checkbox to tab sync
    function attachCheckboxHandlers() {
        tagCheckboxes.forEach(checkbox => {
            // Prevent attaching handler multiple times
            checkbox.removeEventListener('change', checkbox._changeHandler);
            const handler = async () => {
                const selectedOption = checkbox.getAttribute('value');
                const tab = document.querySelector(`.filter_tab[data-tag-name="${selectedOption}"]`);
                if (tab) tab.style.display = checkbox.checked ? "flex" : "none";
                await filterArticles();
                updateUrlWithFilters();
            };
            checkbox.addEventListener('change', handler);
            // store a reference so we can remove it later if needed
            checkbox._changeHandler = handler;
        });
    }

    attachCheckboxHandlers();

    // Filter tab remove logic (for tabs present initially)
    function attachFilterTabHandlers() {
        selectedFilterTabs.forEach(tab => {
            const removeBtn = tab.querySelector('.remove_tag');
            if (!removeBtn) return;
            removeBtn.removeEventListener('click', tab._removeHandler);
            const handler = async () => {
                const tagName = tab.dataset.tagName;
                const checkbox = document.querySelector(`.tag-checkbox[value="${tagName}"]`);
                if (checkbox) checkbox.checked = false;
                tab.style.display = "none";
                await filterArticles();
                updateUrlWithFilters();
            };
            removeBtn.addEventListener('click', handler);
            tab._removeHandler = handler;
        });
    }

    attachFilterTabHandlers();

    // Dropdown open/close
    var element = document.querySelector(".dropdown_btn");
    var dropdown = document.getElementById('BlogTagFilter');
    if (element && dropdown) {
        element.addEventListener('click', function () {
            this.classList.toggle("open");
            dropdown.classList.toggle('open');
        });
        document.addEventListener('click', function (event) {
            if (!element.contains(event.target) && !dropdown.contains(event.target)) {
                element.classList.remove("open");
                dropdown.classList.remove('open');
            }
        });
    }

    // LOAD MORE
    if (loadMoreButton) {
        loadMoreButton.addEventListener('click', async function (event) {
            event.preventDefault();
            if (!nextpageUrl) return;
            loader && (loader.style.display = 'block');
            try {
                const resp = await fetch(nextpageUrl);
                const html = await resp.text();
                loader && (loader.style.display = 'none');
                let tempDiv = document.createElement('div');
                tempDiv.innerHTML = html;
                let blogPosts = tempDiv.querySelectorAll('ul.blog__posts li:not(.tag):not(.spacer)');
                let blogPostsContainer = document.querySelector('ul.blog__posts');
                blogPosts.forEach(post => {
                    // append to DOM (clone to avoid removing references if stored)
                    const cloned = post.cloneNode(true);
                    blogPostsContainer.appendChild(cloned);
                    // store in cache as HTML/tags
                    const tags = post.dataset.tags ? post.dataset.tags.split(',').map(t => t.trim()).filter(Boolean) : [];
                    allArticles.push({ html: post.outerHTML, tags: tags });
                });

                // Update URLs, counters from fetched page
                let nextPageElement = tempDiv.querySelector('[data-next-link]');
                if (nextPageElement) nextpageUrl = nextPageElement.value;
                else nextpageUrl = null;
                let prevPageElement = tempDiv.querySelector('[data-prev-link]');
                if (prevPageElement) prevpageUrl = prevPageElement.value;
                let newCurrent = tempDiv.querySelector('[data-this-page]');
                if (newCurrent) currentpage = parseInt(newCurrent.value);

                // If we've hit last page, mark fetched
                if (!nextpageUrl || currentpage >= totalpage) {
                    allPagesFetched = true;
                    nextpageUrl = null;
                }

                updateButtonVisibility();

                // If filters are active, re-run filtering (this will fetch remaining pages as needed)
                const anyFilterActive = Array.from(document.querySelectorAll('.tag-checkbox')).some(c => c.checked);
                if (anyFilterActive) {
                    await filterArticles();
                }

            } catch (error) {
                loader && (loader.style.display = 'none');
                console.error('Error fetching page:', error);
            }
        });
    }

    // VIEW LESS
    if (viewLessButton) {
        viewLessButton.addEventListener('click', async function(event) {
            event.preventDefault();
            if (!prevpageUrl) return;
            loader && (loader.style.display = 'block');
            try {
                const resp = await fetch(prevpageUrl);
                const html = await resp.text();
                loader && (loader.style.display = 'none');
                let tempDiv = document.createElement('div');
                tempDiv.innerHTML = html;
                let blogPosts = tempDiv.querySelectorAll('ul.blog__posts > li');
                let blogPostsContainer = document.querySelector('ul.blog__posts');
                blogPostsContainer.innerHTML = '';
                blogPosts.forEach(post => {
                    blogPostsContainer.appendChild(post.cloneNode(true));
                });

                // Update URLs, counters
                let nextPageElement = tempDiv.querySelector('[data-next-link]');
                if (nextPageElement) nextpageUrl = nextPageElement.value;
                else nextpageUrl = null;
                let prevPageElement = tempDiv.querySelector('[data-prev-link]');
                if (prevPageElement) prevpageUrl = prevPageElement.value;
                let newCurrent = tempDiv.querySelector('[data-this-page]');
                if (newCurrent) currentpage = parseInt(newCurrent.value);

                // After view less, rebuild cache from DOM (we only keep what's on page now)
                initCacheFromDOM();
                updateButtonVisibility();

                // If any filter active, re-run filter (it will fetch remaining pages only if needed)
                const anyFilterActive = Array.from(document.querySelectorAll('.tag-checkbox')).some(c => c.checked);
                if (anyFilterActive) {
                    await filterArticles();
                }

                // Scroll to top of blog wrapper for UX
                const mainWrapper = document.querySelector('.main-blog-wrapper');
                if (mainWrapper) mainWrapper.scrollIntoView({ behavior: 'smooth' });

            } catch (error) {
                loader && (loader.style.display = 'none');
                console.error('Error fetching page:', error);
            }
        });
    }

    // -- URL FILTER STATE --
    // Function to update URL with selected filters
    function updateUrlWithFilters() {
        const selectedTags = Array.from(document.querySelectorAll('input[type="checkbox"]:checked'))
            .map(checkbox => checkbox.value);
        if (selectedTags.length > 0) {
            const queryString = `?filters=${selectedTags.join(',')}`;
            window.history.replaceState(null, '', queryString);
        } else {
            window.history.replaceState(null, '', window.location.pathname);
        }
    }

    // Function to apply filters from URL on page load
    async function applyFiltersFromUrl() {
        const urlParams = new URLSearchParams(window.location.search);
        const filters = urlParams.get('filters') ? urlParams.get('filters').split(',') : [];
        tagCheckboxes = Array.from(document.querySelectorAll('.tag-checkbox'));
        tagCheckboxes.forEach(checkbox => {
            let filterTab = document.querySelector(`.filter_tab[data-tag_name="${checkbox.value}"], .filter_tab[data-tag-name="${checkbox.value}"]`);
            if (filters.includes(checkbox.value)) {
                checkbox.checked = true;
                if (filterTab) filterTab.style.display = "flex";
            } else {
                checkbox.checked = false;
                if (filterTab) filterTab.style.display = "none";
            }
        });
        // If filters present, run filterArticles (this will fetch additional pages lazily)
        const anyFilterActive = filters.length > 0;
        if (anyFilterActive) {
            await filterArticles();
        }
    }

    // Support removing filter tabs created dynamically (delegated handler)
    document.addEventListener('click', (event) => {
        if (event.target.closest('.remove_tag')) {
            const filterTab = event.target.closest('.filter_tab');
            if (!filterTab) return;
            const tagName = filterTab.dataset.tagName;
            let checkbox = document.querySelector(`input[type="checkbox"][value="${tagName}"]`);
            if (checkbox) {
                checkbox.checked = false;
                // hide tab
                filterTab.style.display = "none";
                updateUrlWithFilters();
                // run filter reset
                filterArticles();
            }
        }
    });

    // On load: ensure button visibility is correct
    updateButtonVisibility();
    // On load: auto-apply filters from URL
    applyFiltersFromUrl();
});












// -----------------------------
// Responsive post-limit helper (SAFE VERSION)
// -----------------------------
(function () {

    // debounce helper
    function debounce(fn, wait) {
        let t;
        return function (...args) {
            clearTimeout(t);
            t = setTimeout(() => fn.apply(this, args), wait);
        };
    }

    // clamp helper
    function clamp(v, min, max) {
        return Math.max(min, Math.min(max, v));
    }

    // Read configured limit from DOM attribute
    function readConfiguredLimit() {
        const wrapper = document.querySelector('.blog__posts.blog__posts-work[data-post-limit]');
        if (wrapper) {
            const raw = wrapper.getAttribute('data-post-limit');
            const v = parseInt(raw, 10);
            if (!isNaN(v) && v > 0) return v;
        }

        if (typeof window !== 'undefined' && Number.isFinite(window.__BLOG_POST_LIMIT__)) {
            return parseInt(window.__BLOG_POST_LIMIT__, 10);
        }

        const postsCount = document.querySelectorAll('.blog-article, ul.blog__posts.blog__posts-work > li:not(.tag):not(.spacer)').length;
        if (postsCount > 0) return postsCount;

        return 0;
    }

    // ---------------------------------------
    // The core function (SAFE, NO LOOPING)
    // ---------------------------------------
    function applyResponsiveLimit() {
        const observer = window.__applyResponsiveObserver__;

        try {
            // ⛔ Pause observer to avoid infinite loop
            if (observer) observer.disconnect();

            const nodes = Array.from(document.querySelectorAll(
                '.blog-article, ul.blog__posts.blog__posts-work > li:not(.tag):not(.spacer)'
            ));
            if (!nodes.length) return;

            let limit = readConfiguredLimit();
            if (!limit || isNaN(limit) || limit < 1) limit = nodes.length;

            const width = window.innerWidth;
            let visibleCount;

            if (width > 989) {
                visibleCount = clamp(limit, 1, nodes.length);
            } else if (width >= 625 && width <= 989) {
                visibleCount = clamp(limit - 1, 1, nodes.length);
            } else {
                visibleCount = clamp(limit, 1, nodes.length);
            }

            nodes.forEach((node, i) => {
                if (node.classList.contains('tag') || node.classList.contains('spacer')) {
                    node.style.display = 'none';
                    return;
                }
                node.style.display = i < visibleCount ? '' : 'none';
            });

        } catch (err) {
            console.error('applyResponsiveLimit error:', err);

        } finally {
            // ✔ Reconnect observer after DOM update
            if (observer) {
                const target = document.querySelector('ul.blog__posts.blog__posts-work');
                if (target) observer.observe(target, { childList: true, subtree: true });
            }
        }
    }

    window.applyResponsiveLimit = applyResponsiveLimit;

    // Initial run + resize
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            applyResponsiveLimit();
            window.addEventListener('resize', debounce(applyResponsiveLimit, 120));
        });
    } else {
        applyResponsiveLimit();
        window.addEventListener('resize', debounce(applyResponsiveLimit, 120));
    }

    // ---------------------------------------
    // Wrap afterButtonClickInit safely
    // ---------------------------------------
    if (typeof afterButtonClickInit === 'function') {
        const orig = afterButtonClickInit;
        window.afterButtonClickInit = function () {
            const res = orig.apply(this, arguments);
            setTimeout(applyResponsiveLimit, 60);
            return res;
        };
    }

    // ---------------------------------------
    // MutationObserver (SAFE version)
    // ---------------------------------------
    (function observePostsContainer() {
        const target = document.querySelector('ul.blog__posts.blog__posts-work');
        if (!target) return;

        const mo = new MutationObserver(
            debounce(() => applyResponsiveLimit(), 80)
        );

        // Start observing
        mo.observe(target, { childList: true, subtree: true });

        // Store globally
        window.__applyResponsiveObserver__ = mo;
    })();


    // ---------------------------------------
    // Wrap filter / loadMore / viewLess
    // ---------------------------------------
    const tryWrap = (name) => {
        if (typeof window[name] === 'function') {
            const orig = window[name];
            window[name] = function () {
                const result = orig.apply(this, arguments);

                if (result && typeof result.then === 'function') {
                    result.then(() => setTimeout(applyResponsiveLimit, 40));
                } else {
                    setTimeout(applyResponsiveLimit, 40);
                }
                return result;
            };
        }
    };

    tryWrap('filterArticles');
    tryWrap('loadMore');
    tryWrap('viewLess');

})();
